<template>
  <div class="originalHeaderDesign">
    <v-app-bar app clipped-left color="white" height="80px">
      <!-- 
<v-app-bar-nav-icon>
</v-app-bar-nav-icon> -->
      <v-toolbar-title>
        <v-flex class="d-flex align-center">
          <slot name="logo" />
        </v-flex>
      </v-toolbar-title>

      <v-tabs hide-slider>
        <v-tab
          class="pl-4"
          v-for="(page, index) in tabList"
          :key="index"
          link
          :to="{ name: page.link }"
        >
          {{ $t(page.name) }}
        </v-tab>
        <v-tab class="pl-4" link @click="shortcut.dialog = true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <img
                :src="require('@/assets/icon_navi_setting.svg')"
                v-on="on"
                width="24"
              />
            </template>
            <span>{{ $t('common.common_ofter-use-screen-settings') }}</span>
          </v-tooltip>
        </v-tab>
      </v-tabs>

      <v-spacer> </v-spacer>

      <v-toolbar-items>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              {{ selectedlang.title }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="onClickLang(lang)"
              v-for="(lang, index) in langs"
              :key="index"
            >
              <v-list-item-title>{{ lang.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-toolbar-items>
        <slot name="alert" />
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              <v-img :src="userIconImageUrl" class="userIcon" />
              <div class="user-info">
                <span class="user-name">{{ userName }}</span>
                <span class="organization-name">{{ organizationName }}</span>
              </div></v-btn
            >
          </template>
          <slot name="user" />
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <CreateShortcut
      v-model="shortcut"
      title="common.common_ofter-use-screen-settings"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CreateShortcut } from '@/components/layouts/Dialogs'
import { langConfig } from '@/config'
import axios from 'axios'

export default {
  props: ['tabList'],
  components: {
    CreateShortcut
  },
  data: () => {
    return {
      langs: [
        { config: langConfig.LANG_JA, title: '日本語' },
        { config: langConfig.LANG_CN, title: '簡体中文' }
      ],
      selectedlang: {},
      userInfo: null,
      shortcut: {
        dialog: false
      }
    }
  },
  created() {
    const currentLang = this.langs.find(
      (lang) => lang.config === this.$i18n.locale
    )
    this.selectedlang = currentLang || this.langs[0]

    // TODO: 現在、ユーザー情報を表示するコンポーネント内で毎回APIからユーザー情報が取得されているため、
    // トップレベルで最初にユーザー情報を取得してコンポーネント内ではstateから使うようした方がよさそう
    this.getUserInfoFromApi().then((response) => {
      this.userInfo = response.data
    })
  },
  methods: {
    ...mapActions('Common', ['setLang']),
    ...mapActions('User', ['getUserInfoFromApi']),
    onClickLang(lang) {
      this.selectedlang = lang
      this.$i18n.locale = lang.config
      axios.defaults.params = { lang: this.$i18n.locale }
      this.setLang(lang.config)
      this.$router.go({ path: this.$router.currentRoute.path, force: true })
    }
  },
  computed: {
    userIconImageUrl() {
      const defaultIcon = require('@/assets/icon_user_default.svg')
      return this.userInfo?.iconImgUrl || defaultIcon
    },
    userName() {
      if (!this.userInfo) return ''
      return `${this.userInfo.lastName} ${this.userInfo.firstName}`
    },
    organizationName() {
      return this.userInfo?.organization.name || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.originalHeaderDesign {
  .user-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .user-name {
      font-size: 14px;
      color: #666;
    }
    .organization-name {
      font-size: 12px;
      color: #ccc;
    }
  }
  .v-toolbar {
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1) !important;
  }
  .v-toolbar__title {
    overflow: visible !important;
    margin-right: 50px !important;
  }
}
.userIcon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
